import {
  reportEvent as dataRangersReportEvent,
  setRegisterPage as dataRangersSetRegisterPage,
  dataRangersSignOut,
  dataRangersSignUp,
  initDataFinder,
} from './data-finder-event';
import { DATA_FINDER_PLATFORM_TYPES, type DataFinderPlatformType } from './platform-type';

export { resolveDataFinderPlatformType } from './platform-type';

type SensorEvent =
  | [
      'track',
      {
        eventName: string;
        properties?: Record<string, string | boolean | number>;
      },
    ]
  | ['registerPage', Record<string, string | boolean>]
  | ['login', string]
  | ['logout'];

let hasLoaded = false;
const unReportEvent: SensorEvent[] = [];

export const initSensors = (platformType: DataFinderPlatformType = DATA_FINDER_PLATFORM_TYPES.web) => {
  initDataFinder(platformType);
  for (const [sensorEvent, properties] of unReportEvent) {
    if (sensorEvent === 'track') {
      dataRangersReportEvent(properties.eventName, properties.properties);
    } else if (sensorEvent === 'registerPage') {
      dataRangersSetRegisterPage(properties);
    } else if (sensorEvent === 'login') {
      dataRangersSignUp(properties);
    } else {
      dataRangersSignOut();
    }
  }
  hasLoaded = true;
};

const checkSensor = (event: SensorEvent) => {
  if (!hasLoaded) {
    unReportEvent.push(event);
    return false;
  }
  return true;
};

/**
 * 自定义上报事件
 * @param eventName
 * @param properties
 */
export function reportEvent(eventName: string, properties?: Record<string, string | boolean | number>) {
  if (!checkSensor(['track', { eventName, properties }])) return;
  dataRangersReportEvent(eventName, properties);
}

/**
 * 设置公共属性
 * @param profile
 * @returns
 */
export function setRegisterPage(profile: {
  uid?: string;
  language?: string;
  is_member?: boolean;
  member_type?: string;
}) {
  if (!checkSensor(['registerPage', profile])) return;
  dataRangersSetRegisterPage(profile);
}

export function sensorsSignUp(id: string) {
  if (!checkSensor(['login', id])) return;
  dataRangersSignUp(id);
}

export function sensorsSignOut() {
  if (!checkSensor(['logout'])) return;
  dataRangersSignOut();
}
